export default __webpack_public_path__ + "static/media/cycloneofset.716ecb4a.png";